import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import dayjs from 'dayjs';
import localeRu from 'dayjs/locale/ru';
import localeEn from 'dayjs/locale/en-gb';
import pluginIsToday from 'dayjs/plugin/isToday';
import pluginIsYesterday from 'dayjs/plugin/isYesterday';
import pluginCalendar from 'dayjs/plugin/calendar';
import pluginUpdateLocale from 'dayjs/plugin/updateLocale';
import pluginLocalizedFormat from 'dayjs/plugin/localizedFormat';
import pluginIsSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import pluginRelativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(pluginIsToday);
dayjs.extend(pluginIsYesterday);
dayjs.extend(pluginCalendar);
dayjs.extend(pluginUpdateLocale);
dayjs.extend(pluginLocalizedFormat);
dayjs.extend(pluginIsSameOrAfter); // https://day.js.org/docs/en/customization/relative-time

dayjs.extend(pluginRelativeTime, {
  thresholds: [{
    l: 's',
    r: 1
  }, {
    l: 'm',
    r: 1
  }, {
    l: 'mm',
    r: 59,
    d: 'minute'
  }]
});
dayjs.updateLocale('ru', {
  calendar: {
    lastDay: '[Вчера в] H:MM',
    sameDay: '[Сегодня в] H:MM'
  },
  relativeTime: _objectSpread({}, localeRu.relativeTime, {
    m: 'Минуту'
  })
});
dayjs.updateLocale('en', {
  calendar: {
    lastDay: '[Yesterday at] H:MM a',
    sameDay: '[Today at] H:MM a'
  },
  relativeTime: _objectSpread({}, localeEn.relativeTime, {
    m: 'A minute'
  })
});
export default dayjs;